import React from 'react';
import { useLocation } from 'react-router-dom';
import PositionList from '../components/PositionList';
import { usePortfolioContext } from '../contexts/PortfolioContext';
import PortfolioRequired from '../components/PortfolioRequired';

const StockPositionsPage = () => {
  const { currentPortfolioId } = usePortfolioContext();
  const location = useLocation();
  if (!currentPortfolioId) {
    return <PortfolioRequired title="Stock positions" description="Please select a portfolio to view stock positions." />;
  }
  return (
    <div className="px-2 sm:px-3 lg:px-4 py-2">
      <PositionList assetKind="stock" navState={location?.state} />
    </div>
  );
};

export default StockPositionsPage;
